import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight, BookOpen } from "lucide-react";
export default function BlackButton() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-primary via-primary/90 to-primary/80">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/stock_market_chart_background.png)] bg-cover bg-center opacity-10" />
      
      {}
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {}
          <div className="flex justify-center mb-8">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/website_logo_zi_white.png" className="h-7" alt="ZI" />
          </div>

          {}
          <div className="space-y-6 animate-fade-in-up">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-display font-bold text-white leading-tight">
              Domina el Mercado de Valores Estadounidense
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              Formación profesional en trading e inversión. Aprende estrategias comprobadas y herramientas avanzadas para maximizar tu rendimiento en la bolsa.
            </p>
          </div>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button asChild size="lg" className="bg-accent hover:bg-accent-hover text-accent-foreground shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] min-w-[200px]">
              <Link to="/CursosPage">
                <BookOpen className="size-5" />
                Ver Webinar
              </Link>
            </Button>

            <Button asChild size="lg" className="bg-yellow-500 hover:bg-yellow-600 text-white shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] min-w-[200px] border border-white/10">
              <Link to="/ContactoPage">
                <ArrowRight className="size-5" />
                Comenzar Ahora
              </Link>
            </Button>
          </div>

          {}
          <div className="pt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="glass-effect p-6 hover-lift" data-index={0}>
              <div className="text-3xl font-bold text-white">500+</div>
              <div className="text-white/80 text-sm mt-2">Estudiantes Activos</div>
            </div>
            <div className="glass-effect p-6 hover-lift" data-index={1}>
              <div className="text-3xl font-bold text-white">95%</div>
              <div className="text-white/80 text-sm mt-2">Tasa de Satisfacción</div>
            </div>
            <div className="glass-effect p-6 hover-lift" data-index={2}>
              <div className="text-3xl font-bold text-white">24/7</div>
              <div className="text-white/80 text-sm mt-2">Acceso a Recursos</div>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>;
}